import classNames from 'classnames';

import { Button } from './button';
import { ButtonProps } from './button.types';
import { BUTTON_VARIANT_M, BUTTON_VARIANT_OUTLINE } from './config';

export const ButtonAccentSecondary = ({
  disabled,
  variant = BUTTON_VARIANT_M,
  children,
  className,
  ...props
}: ButtonProps) => {
  return (
    <Button
      disabled={disabled}
      {...props}
      className={classNames(className, {
        'text-accent fill-accent-secondary focus:fill-accent-secondary-active':
          !disabled && variant !== BUTTON_VARIANT_OUTLINE,
        'fill-accent-secondary-disabled text-accent-disabled': disabled && variant !== BUTTON_VARIANT_OUTLINE,
        'bg-transparent text-accent-disabled': disabled && variant === BUTTON_VARIANT_OUTLINE,
        'hover:text-accent-no-bg bg-transparent focus:bg-transparent focus:text-accent-no-bg':
          variant === BUTTON_VARIANT_OUTLINE && !disabled,
      })}
      variant={variant}>
      {children}
    </Button>
  );
};
